const types = {
  SET_COMPANY_CATEGORIES: 'SET_COMPANY_CATEGORIES',
  SET_COMPANY_ALL_USERS: 'SET_COMPANY_ALL_USERS',
  SET_COMPANY_USERS: 'SET_COMPANY_USERS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/settings/mutations-types.js